{
	"analystsForecast": {
		"strongBuy": "Активно покупать",
		"buy": "Покупать",
		"neutral": "Нейтрально",
		"sell": "Продавать",
		"strongSell": "Активно продавать",
		"countAnalysts": "Основан на оценке акций {{symbol}} от {{count}} аналитиков.",
		"conclusion": "Прогноз аналитиков"
	}
}
